import React from 'react';
import { useTranslation } from 'react-i18next';

function ProfileEmailChangeModal({
  isOpen,
  currentEmail,
  form,
  errors,
  isSaving,
  onChange,
  onClose,
  onSave,
}) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
      <div className="modal-dialog">
        <form className="modal-content" onSubmit={onSave}>
          <div className="modal-header">
            <h5 className="modal-title">{t('profiles.changeEmail')}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label={t('common.cancel')}
              onClick={onClose}
              disabled={isSaving}
            ></button>
          </div>
          <div className="modal-body">
            {errors.form ? <div className="alert alert-danger py-2">{errors.form}</div> : null}

            <div className="mb-3">
              <label className="form-label" htmlFor="profile-current-email">{t('profiles.currentEmail')}</label>
              <input id="profile-current-email" type="text" className="form-control" value={currentEmail || ''} disabled />
            </div>
            <div className="mb-3">
              <label className="form-label" htmlFor="profile-new-email">{t('profiles.newEmail')}</label>
              <input
                id="profile-new-email"
                type="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                value={form.email}
                onChange={(event) => onChange('email', event.target.value)}
                disabled={isSaving}
              />
              {errors.email ? <div className="invalid-feedback">{errors.email}</div> : null}
            </div>
            <div className="mb-0">
              <label className="form-label" htmlFor="profile-email-change-reason">{t('profiles.emailChangeReason')}</label>
              <textarea
                id="profile-email-change-reason"
                className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                value={form.reason}
                onChange={(event) => onChange('reason', event.target.value)}
                rows={3}
                disabled={isSaving}
              />
              {errors.reason ? <div className="invalid-feedback">{errors.reason}</div> : null}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" onClick={onClose} disabled={isSaving}>
              {t('common.cancel')}
            </button>
            <button type="submit" className="btn btn-primary" disabled={isSaving}>
              {isSaving ? t('profiles.savingProfile') : t('common.save')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProfileEmailChangeModal;
